import { MessageMedium } from 'constants/messageMediums';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export interface CreateCampaignState {
  messageMedium: MessageMedium;
  setMessageMedium: (value: MessageMedium) => void;
  hasApprovedBusinessTemplates: boolean;
  setHasApprovedBusinessTemplates: (value: boolean) => void;
}

export const CreateCampaignContext = createContext<CreateCampaignState>({
  messageMedium: MessageMedium.Email,
  setMessageMedium: noop,
  hasApprovedBusinessTemplates: false,
  setHasApprovedBusinessTemplates: noop,
});

export const useCreateCampaignContext = () => useContext(CreateCampaignContext);
